import { PaymentRefundList } from 'pages/financial/payment_refunds';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'order_payment_refunds',
  label: 'Reembolso Parcial',
  list: PaymentRefundList,
  actions: ['list', 'create', 'approve'],
  parentName: 'financial'
};

export default generateResources(resource);
